import {
  Box,
  buildPath,
  buildTemplatePath,
  Grid,
  Page,
  PageRoute,
  Stack,
  useElementBreakpoints
} from "@compass/core";
import {
  LkPersonTypeId,
  TextingConversationListResource,
} from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { TextingMessageProvider } from "../NewTextingMessageContext";
import { ChatScreen } from "./ChatScreen/ChatScreen";
import { Conversations } from "./Conversations";
import { PersonTypeTabs } from "./PersonTypeTabs";
import { TextingConversationsPageHeader } from "./TextingConversationsPageHeader";
import { Outlet } from "react-router-dom";

const routeName = "Conversations";

export const textingConversationsPageRoute: PageRoute = {
  handle: "Conversations",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export type TextingConversationTab = {
  personTypeId: number;
  personType: "Student" | "Parent" | "Staff";
};

export const TextingConversationsPage = () => {
  const [personTypeId, setPersonTypeId] = useState<number>(LkPersonTypeId.Student);
  const [selectedConversationId, setSelectedConversationId] = useState<number>();

  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<TextingConversationListResource>({});

  useEffect(() => {
    fetchResource();
  }, []);

  const fetchResource = () => {
    ApiService.textingConversations.getListResource().then((response) => {
      setResource(response);
    });
  };

  const pageHeader = <TextingConversationsPageHeader handle={textingConversationsPageRoute.handle} />;

  return (
    <TextingMessageProvider>
      <Page isForm header={pageHeader}>
        <Stack ref={breakpointsRef} spacing="md" height="100%">
          <PersonTypeTabs personTypes={resource.personTypes ?? []} value={personTypeId} onChange={setPersonTypeId} />

          <Box overflow="auto" flexGrow={1}>
            <Grid container spacing="md" height="100%">
              <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} height="100%">
                <Box height="100%" overflow="auto">
                  <Conversations
                    personTypeId={personTypeId}
                    selectedConversationId={selectedConversationId}
                    setSelectedConversationId={setSelectedConversationId}
                  />
                </Box>
              </Grid>

              {selectedConversationId && (
                <Grid item xs={setBreakpoints({ md: 8, xs: 12 })} height="100%">
                  <Box height="100%" overflow="auto">
                    <ChatScreen conversationId={selectedConversationId} />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Stack>

      </Page>
      <Outlet />
    </TextingMessageProvider>
  );
};
